import { render, staticRenderFns } from "./PricePanel.vue?vue&type=template&id=66d5e55e&scoped=true&"
import script from "./PricePanel.vue?vue&type=script&lang=js&"
export * from "./PricePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d5e55e",
  null
  
)

export default component.exports